import FeaturedCitiesInfo from 'ha/constants/FeaturedCities';
import { City } from 'ha/services/apiV2/types';
import { FeaturedLink } from '../components/FeaturedLinks/FeaturedLinks';

export const filterHiddenCities = (cities: City[]): City[] => {
  return cities.filter(
    item => !FeaturedCitiesInfo[item.cityCanonical]?.isHidden,
  );
};

export const filterApartments = (cities: City[]): City[] => {
  return cities.filter(
    item => FeaturedCitiesInfo[item.cityCanonical]?.hasAppartmentLink,
  );
};

export const filterPrivateRooms = (cities: City[]): City[] => {
  return cities.filter(
    item => FeaturedCitiesInfo[item.cityCanonical]?.hasRoomLink,
  );
};

export const citiesToFeaturedLinks = (cities: City[]): FeaturedLink[] => {
  return cities.map(({ cityName, countryName, searchUrl }) => ({
    url: searchUrl,
    title: `${cityName}, ${countryName}`,
    textContent: [`${cityName}`, `, ${countryName}`],
  }));
};
